import React from "react";
import { CardText, CardActions, Button } from "react-md";
import CenteredSection from "../../../common/components/CenteredSection";
import RegistrationCard from "../RegistrationCard";

const NotFoundPage = ({ currentRegistration, onSubmit }) => (
  <CenteredSection size={6} offset={3}>
    <RegistrationCard
      title="Are you new to Orlando Gun Club?"
      subtitle={`We were unable to find ${currentRegistration.email}.`}
    >
      <CardText />
      <CardActions>
        <Button
          raised
          label="No, Try Another Email"
          className="md-cell--left"
          secondary
          onClick={() =>
            onSubmit({
              cancel: true
            })}
        />
        <Button
          raised
          label="Yes, I'm New"
          className="md-cell--right"
          primary
          onClick={() =>
            onSubmit({
              nextStep: "contact-info"
            })}
        />

      </CardActions>
    </RegistrationCard>
  </CenteredSection>
);

NotFoundPage.propTypes = {};
NotFoundPage.defaultProps = {};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/registration/components/NotFound/NotFoundPage.jsx